var slideSwiperCards = new Swiper(".bpo__swiper--cards", {
    direction: "horizontal",
    spaceBetween: 100,
    autoplay: false,
    loop: true,
    allowTouchMove:false,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
    },
    effect: 'creative',
    creativeEffect: {
        next: {
            translate: ["-30px", "-30px", -0.95],
            shadow: false
        },
        prev: {
            translate: ["-30px", "-30px", -0.95],
        }
    },
    breakpoints: {
        768: {
        }
    }
});

var slideSwiperCardArticle = new Swiper(".bpo__swiper--cardArticle", {
    direction: "horizontal",
    spaceBetween: 20,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    loop: true
});

var slideVendorImgSP = new Swiper(".bpo__swiper--imgSP", {
    direction: "horizontal",
    spaceBetween: 0,
    slidesPerView: 1,
    speed: 1000,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false
    },
    loop: true,
    effect: 'fade'
});

var slideVendorImgPC = new Swiper(".bpo__swiper--imgPC", {
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 3,
    speed: 5000,
    allowTouchMove: false,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true
    },
    loop: true,
    pagination: {
        el: ".vendor-pagination",
        clickable: true
    },
    breakpoints: {
        768: {
            slidesPerView: 5
        },
        992: {
            slidesPerView: 6
        },
        1280: {
            slidesPerView: 7
        },
        1600: {
            slidesPerView: 8
        },
        1920: {
            slidesPerView: 9
        }
    }
});
